import {Helmet} from 'react-helmet';
import { logoHorizontal } from '../../../assets'

const SocialMetaTags = () => {
  const title = 'Trading Options Like The Pros'
  const description = 'Trading Options Like The Pros.'

  return (
    <Helmet>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={logoHorizontal} />
      <meta property="og:url" content={location.hostname} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:url" content={logoHorizontal} />
    </Helmet>
  );
};

export default SocialMetaTags;
